interface NestedObjectType {
  Highcharts?: Highcharts.Options;
  [key: string]: NestedObjectType | string | number | boolean | Highcharts.Options;
}

export const flatToNestedObject  = (input:Record<string, string | boolean | number>):NestedObjectType => {
  const output = {};
  for (const key in input) {
    if (input.hasOwnProperty(key)) {
      const keys = key.split('.');
      let currentLevel = output;

      keys.forEach((nestedKey, index) => {
        if (!currentLevel[nestedKey]) {
          if (index === keys.length - 1) {
            currentLevel[nestedKey] = input[key];
          } else {
            currentLevel[nestedKey] = {};
          }
        }
        currentLevel = currentLevel[nestedKey];
      });
    }
  }
  return output;
};
